import { Facebook, Instagram, Linkedin, MoveUp, Rss, Youtube } from 'lucide-react'
import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { Link, useNavigate } from 'react-router-dom'
import Formvalidators from '../validators/Formvalidators'


export default function Footer1() {
  let [show,setShow]= useState(false)
  let navigate = useNavigate()
  let [data,setData]=useState({
    email:""
  })
  
  let [errorMessage,setErrorMessage]= useState({
    email:"Email Field Is Required"  
  })
  
  function getInput(e){
    let {name, value}= e.target
    if(name==="email"){
        setErrorMessage((old)=>{
          return{
            ...old,
            email:Formvalidators(e)
          }
         })
        setData((old)=>{
          return{
            ...old,
            [name]:value
          }
         })
      
      
    }
  }

async function postData(e) {
  e.preventDefault();

  try {
    // Validate errors
    let error = Object.values(errorMessage).find((x) => x?.length > 0);
    if (error) {
      setShow(true);
      return;
    }
    else{
        let res = await fetch("http://34.228.14.188:8000/api/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

     res = await  res.json()
     if(res.result==="Done"){
        toast.success("Thanks For Subscribe !");
        setData({ email: "" }); 
        window.location.reload()
     }
     else{
        toast.error("Internal Server Error")
     }

    }
  
  } catch (err) {
    console.error("Error posting data:", err);
  }
}

  





  function scrollToTop(){
    window.scroll({
      top:0,
      behavior:"smooth"
    })
  }
  return (
   <>
     <div className="container-fluid footer-parent bg-dark  text-light footer wow fadeIn " data-wow-delay="0.1s">
     <div className="container pb-5">
         <div className="row g-5">
           <div className="col-md-6 col-lg-6">
                <div className="row">
                  <div className="col-md-12">
                      <img src="/images/white.png" height={100} width={170} alt="vtheHotel-theGrand-shoba-footer-logo" title='vtheHotel-theGrand-shoba-footer-logo' />
                      <p className='footer-para'>SUBSCRIBE FOR LATEST UPDATES</p>
                      <div className="subscribe d-flex">
                        <input type="email" name='email' value={data.email} className={`${show && errorMessage? "border-danger":""} `} onChange={getInput}  placeholder='Enter Your Email Address*'/> 
              
                        <button className=' subscribe-btn ' onClick={postData} > SUBSCRIBE</button>
                      </div>
                      <div className="footer-booking">
                        <p className='footer-para'>FOR BOOKING CONTACT </p>
                        <a href="tel:+919811320209"> +91 9811320209</a>
                        <a href="tel:+919811226576" className='footer-support-booking'> +91 9811226576</a>
                      </div>
                      <div className="footer-support">
                        <p className='footer-para'>CUSTOMER SUPPORT</p>
                        <a href="mailto:info@vhotelthegrandshoba.com"> info@vhotelthegrandshoba.com</a>
                        <a href="mailto:booking@vhotelthegrandshoba.com" className='footer-support-links'> booking@vhotelthegrandshoba.com</a>
                        
                      </div>
                  </div>
                 
                  {/* <div className="col-md-6">
                    subscribe
                    </div> */}
                </div>
            
             </div>

            
            <div className="col-md-6 col-lg-6 ">
               <div className="row">
                 <div className="col-md-6">
                 <div className='quick-links'>
                   <h5 className='footer-para'>QUICK LINKS</h5>
                    <ul>
                      <Link to="/"> HOME </Link>
                      <Link to="/dining"> DINING </Link>
                      <Link to="/rooms"> ROOMS </Link>
                      <Link to="/corporate">CORPORATE</Link>
                      <Link to="/contact-us"> CONTACT US </Link>
                      <Link to="/corporate#events">EVENTS</Link>
                      <Link to="/gallery"> GALLERY</Link>
                    </ul>
                  </div>
                 </div>
                 {/* social media links  */}
                 <div className="col-md-6">
                 <div className='quick-links'>
                   <h5 className='footer-para'>CONNECT WITH US</h5>
                   <div className="footer-social-mediaLinks">
                   <Link to="https://www.facebook.com/photo/?fbid=843991709002364&set=a.843991509002384" target='_blank'>   <Facebook  className='me-4 footer-social-icon'/></Link>
                   <Link to="www.youtube.com" target='_blank'>    <Youtube  className='me-4 footer-social-icon'/></Link>
                   <Link to="www.linkdin.com" target='_blank'>   <Linkedin  className='me-4 footer-social-icon'/></Link>
                   <Link to="www.instagram.com" target='_blank'>   <Instagram  className='me-4 footer-social-icon'/></Link>
                   </div>
                  </div>
                  
          <div className="map-section-footer">
        <iframe
          title="hotel-location"
          src="https://maps.google.com/maps?q=V+Hotel+The+Grand+Shoba%2C+1031%2C+Mahipalpur+%2C+Vasant+kunj+Bypass%2C+Road%2C+Mahipalpur+Extension%2C+New+Delhi%2C+delhi%2C+Delhi+110037&layer=c&output=embed"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          className='contactus-map-footer'
        ></iframe>
                         </div>
                 </div>


                 
               </div>

            </div>
            

             <hr />
                  {/* <p className='footer-para'>DESTINATIONS</p> */}
              {/* <hr /> */}

{/* our brands */}      

                {/* <div className="footer-brand">
                  <div className="footer-brand-img">
                  <img src="/images/logow1.png" className='me-5'  height={50} width={100} alt="" />
                    <img src="/images/logow1.png" className='me-5'  height={50} width={100} alt="" />
                    <img src="/images/logow1.png" className='me-5'  height={50} width={100} alt="" />
                    <img src="/images/logow1.png" className='me-5'  height={50} width={100} alt="" />
                    <img src="/images/logow1.png" className='me-5'  height={50} width={100} alt="" />
                    <img src="/images/logow1.png" className='me-5'  height={50} width={100} alt="" />
                    <img src="/images/logow1.png" className='me-5'  height={50} width={100} alt="" />
                    <img src="/images/logow1.png" className='me-5'  height={50} width={100} alt="" />
                  </div>
                </div> */}
             {/* <hr /> */}

          <div className="row">
          <div className="col-md-6">
            <p>© 2025 The V Grnad Shoba. All Rights Reserved. Developed by <a className=" text-decoration-none" href="https://www.perfectconsultancy.co/" target="_blank"> <span className="border-bottom border-600 border-2" style={{lineHeight:"10px", marginBottom: "10px",color:"white"}}>PGC  </span></a></p>
            </div>
           <div className="col-md-6">
           <div className="footer-copyright-links">
             <Link to="/cancellationandrefund">CANCELLATION & REFUND</Link>|
             <Link to="/privacypolicy">PRIVACY-POLICY</Link> | 
             <Link to="/termsandconditions">TERM AND CONDITION</Link> | 
             <Link to="/">ABOUT US</Link> 
            </div>
           </div>
           </div>
             </div>
          </div>
          <div className="scroll-to-top" onClick={scrollToTop}>
          <MoveUp  className='scroll-to-top-icon' />
          </div>

        </div>
   </>
  )
}
